const downloadData = [
    {
        "appNo": "202100015",
        "appType": "followUp1",
        "files": [
            {
                "type": "",
                "size": 0,
                "bytes": "",
                "name": "驗證費用補助申請書.docx",
                "lastModified": 0
            }
        ]
    },
    {
        "appNo": "202100016",
        "appType": "renewal",
        "files": [
            {
                "type": "",
                "size": 0,
                "bytes": "",
                "name": "驗證費用補助申請書.docx",
                "lastModified": 0
            },
            {
                "type": "",
                "size": 0,
                "bytes": "",
                "name": "契約書.docx",
                "lastModified": 0
            }
        ]
    }
]

export default downloadData